import React from 'react';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';

type FCProps = {
  message: string;
  imgSrc?: string;
};

const WelcomeHeader = ({ message, imgSrc }: FCProps): JSX.Element => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center'
    }}
  >
    <Avatar alt={message} src={imgSrc} sx={{ width: 48, height: 48 }} />
    <Box pl={3}>
      <Typography variant="h6" component="h3" fontWeight="bold">
        {message}
      </Typography>
    </Box>
    
  </div>
);

export default WelcomeHeader;
